import React, { useEffect, useRef, useState } from 'react'
import Header from '../components/Header'
import Leftmenu from '../components/Leftmenu'
import Rightmenu from '../components/Rightmenu'
import { useOutletContext, useParams } from 'react-router-dom'
import GroupJoiningCard from '../components/GroupJoiningCard'
import PostCard from '../components/PostCard'
function Group() {
    const [loader, setLoader] = React.useState(false);
    const {user, token} = useOutletContext();
   const { id } = useParams();
   const [groupInfo, setGroupInfo] = React.useState({});
   const [page, setPage] = React.useState('group');
   const [groupRequests, setGroupRequests] = React.useState([]);
   const [groupMembers, setGroupMembers] = React.useState([]);
    const [Posts, setPosts] = React.useState([]);
        const [hasMore, setHasMore] = useState(true);
                const [selectedImages, setSelectedImages] = useState([]);
    const [pageno, setPageno] = React.useState(1);
         const loaderRef = useRef(null);
 
            const [loading, setLoading] = useState(false);
    
    const getGroupInfo = () => {
        
        setLoader(true);
        fetch('/api/get-group-info', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({group_id: id})
        }).then((response) => response.json())
            .then((data) => {
                setGroupInfo(data.data);
                setLoader(false);
        }).catch((error) => {
            console.log(error);
            setLoader(false);
        });
    }
    const getGroupRequests = () => {
        setLoader(true);
        fetch('/api/get-group-requests', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({group_id: id})
        }).then((response) => response.json())
            .then((data) => {
                setGroupRequests(data.data);
                console.log(data);
                setLoader(false);
        }).catch((error) => {
            console.log(error);
            setLoader(false);
        });
    }
    const getGroupPosts = () => {
        setLoader(true);
        fetch('/api/group-posts?page=' + pageno, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({group_id: id})
        }).then((response) => response.json())
        .then((data) => {
              if (data.data.data && data.data.data.length > 0) {
            // Use functional update to get latest posts
            setPosts((prevPosts) => [...prevPosts, ...data.data.data]);
           
            setHasMore(data.data.data.length > 0);
        } else {
            console.log("No more data");
            setHasMore(false); // no more data
        }
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoader(false);
        })
            }
            
        
    useEffect(() => {
        if(page === 'group'){
            getGroupInfo();
            getGroupPosts();
        }else if(page === 'join-request'){
            getGroupRequests();
        }else if(page === 'members'){
            getGroupMembers();
        }
        console.log(page);
    },[page]);

    const getGroupMembers = () => {
        fetch('/api/get-group-members', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({id: id})
        }).then((response) => response.json())
        .then((data) => {
            if(data.data){
                setGroupMembers(data.data);
            }else{
                setGroupMembers([]);
            }
        })
        .catch((error) => {
            console.log(error);
        })}
        
    


    //Post Logic 
   
    
              
                const handleImageChange = (e) => {
                    const selectedImages = e.target.files;
                    setSelectedImages([...selectedImages]);
                    console.log(selectedImages);
                }
                const postCreate= (e) => {
                    e.preventDefault();
                    const formData = new FormData();
                    for (let i = 0; i < selectedImages.length; i++) {
                        formData.append('images[]', selectedImages[i]);
                    }
                    formData.append('group_id', id);
                    formData.append('content', e.target.message.value);
                    fetch('/api/group-post-create', {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                        body: formData,
                    }).then((response) => response.json())
                    .then((data) => {
                        if (data.extraerror) {
                            
                        }
                        else if(data.data && data.message) {
                            console.log("Success:", data);
                            e.target.reset();
                             e.target.reset();
                            setSelectedImages([]);
                            setPosts([data.data ,...Posts]);
                        }
        
                      
                    }).catch((error) => {
                        console.log(error);
                    });
                }
             // Watch for loader in viewport
      useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setPageno(prevPageno => {
              if (!loading && hasMore) {
                return prevPageno + 1;
              }
              return prevPageno;
            });
          }
        },
        { threshold: 0.1 }
      );
    
      if (loaderRef.current) observer.observe(loaderRef.current);
      return () => {
        if (loaderRef.current) observer.unobserve(loaderRef.current);
      };
    }, [loading, hasMore]);
    
    
      // Fetch new posts when page changes
      useEffect(() => {
        if (pageno > 1) {
          getGroupPosts();
        }
      }, [pageno]);
  return (
    <div>
        <Header />
        <Leftmenu />
        <Rightmenu />
      <div className="main-content right-chat-active">
  <div className="middle-sidebar-bottom">
    <div className="middle-sidebar-left">
      <div className="row">
        <div className="col-xl-4 col-xxl-3 col-lg-4 pe-0">
          <div className="card w-100 shadow-xss rounded-xxl overflow-hidden border-0 mb-3 mt-3 pb-3">
          
            <div className="card-body d-block pt-4 text-center">
              <h4 className="font-xs ls-1 fw-700 text-grey-900">{groupInfo.name} </h4>
            </div>
            <div className="card-body d-flex align-items-center justify-content-center ps-4 pe-4 pt-0">
              <h4 className="font-xsssss text-center text-grey-500 fw-600 ms-2 me-2 d-flex flex-column"><b className="text-grey-900 mb-1 font-xss fw-700 d-inline-block ls-3 text-dark">{groupInfo.alumni_posts_count} </b> Posts</h4>
              <h4 className="font-xsssss text-center text-grey-500 fw-600 ms-2 me-2 d-flex flex-column"><b className="text-grey-900 mb-1 font-xss fw-700 d-inline-block ls-3 text-dark">{groupInfo.alumni_group_members_count} </b> Members</h4>
            </div>
            <div className="card-body d-flex flex-column align-items-center justify-content-center ps-4 pe-4 pt-0">
                { page != 'join-request' &&  (
                    user.id == groupInfo.created_by &&
                    <a href="#" onClick={() => {setPage('join-request')}} className="bg-current text-white p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 ls-3">View Joining Request</a>
                )}
                { page != 'group' &&  (
                    <span>

                    <br />
                    <a href="#" onClick={() => {setPage('group')}} className="bg-current text-white p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 ls-3">Group Post</a>
                    </span>
                )}
              

                { page != 'members' &&  (
                    
                    <span>
                    <br />
                    <a href="#" onClick={() => {setPage('members')}} className="bg-current text-white p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 ls-3">Group Members</a>
                    </span>                    
                )}
         

            </div>
          </div>
          <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
            <div className="card-body d-block p-4">
              <h4 className="fw-700 mb-3 font-xsss text-grey-900">About</h4>
              <p className="fw-500 text-grey-500 lh-24 font-xssss mb-0">{groupInfo.description}</p>
            </div>
            
          </div>
          
    
          
        </div>
        {
            page === 'group' && 
        
        <div className="col-xl-8 col-xxl-9 col-lg-8">

              <form onSubmit={postCreate} className="card w-100 shadow-xss rounded-xxl border-0 ps-4 pt-4 pe-4 pb-3 mb-3 my-2" >

                                <div className="card-body p-0">
                                    <div href="#" className=" font-xssss fw-600 text-grey-500 card-body p-0 d-flex align-items-center"><i className="btn-round-sm font-xs text-primary feather-edit-3 me-2 bg-greylight"></i>Create Post</div>
                                </div>
                                <div className="card-body p-0 mt-3 position-relative">
                                    <figure className="avatar position-absolute ms-2 mt-1 top-5"><img src={user?.personal_info.profile_picture} alt="image" className="shadow-sm rounded-circle w30" /></figure>
                                    <textarea id='message' name="message" className="h100 bor-0 w-100 rounded-xxl p-2 ps-5 font-xssss text-grey-500 fw-500 border-light-md theme-dark-bg" cols="30" rows="10" placeholder="What's on your mind?"></textarea>
                                </div>
                           

                                    {selectedImages.length > 0 && (
                                        <div className="row ps-2 pe-2">
                                            {selectedImages.slice(0, 2).map((image, index) => (
                                                <div key={index} className="col-xs-4 col-sm-4 p-1">
                                                    <div href={URL.createObjectURL(image)} data-lightbox="roadtrip">
                                                        <img className="rounded-3 w-100" alt="image" src={URL.createObjectURL(image)} />
                                                    </div>
                                                </div>
                                            ))}
                                            {selectedImages.length > 2 && (
                                                <div className="col-xs-4 col-sm-4 p-1">
                                                    <div href={URL.createObjectURL(selectedImages[2])} data-lightbox="roadtrip" className="position-relative d-block">
                                                        <img className="rounded-3 w-100" alt="image" src={URL.createObjectURL(selectedImages[2])} />
                                                      {selectedImages.length > 3 && (
                                                            <span className="img-count font-sm text-white ls-3 fw-600">
                                                                <b>+{selectedImages.length - 3}</b>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                   
                                <div className="card-body d-flex p-0 mt-0 justify-content-between">
                                    <input type="file" id='file-upload' className='visually-hidden' multiple accept="image/*" onChange={handleImageChange} />

                                    <label htmlFor="file-upload" className="d-flex align-items-center font-xssss fw-600 ls-1 text-grey-700 text-dark pe-4" style={{cursor: 'pointer'}}> <i className="font-md text-success feather-image me-2"></i><span >Attach Photos (max 10 images)</span></label>

                                  <button type="submit" className="p-2 lh-20 w100 bg-primary-gradiant me-2 text-white text-center font-xssss fw-600 ls-1 rounded-xl color-theme-red btn">Post</button>
                                </div>
                            </form>

                            {
                                Posts.length > 0 && Posts.map((post) => (
                                  <PostCard
                                    key={post.id}
                                    post={post}
                                    onDelete={(deletedId) =>
                                      setPosts((prev) => prev.filter((p) => p.id !== deletedId))
                                    }
                                  />
                                ))
                            }

                              {/* Loader (Triggers IntersectionObserver) */}
                  { (
                    <div
                      ref={loaderRef}
                      className="card w-100 text-center shadow-xss rounded-xxl border-0 p-4 mb-3 mt-3"
                    >
                      {hasMore ? (
                        <div className="snippet mt-2 ms-auto me-auto">
                          <div className="stage">
                            <div className="dot-typing"></div>
                          </div>
                        </div>
                      ) : (
                        <p className="text-muted mb-0">You have reached the end</p>
                      )}
                    </div>
                  )}
        </div>                             
        }
        {
            page === 'join-request' &&
            <div className="col-xl-8 col-xxl-9 col-lg-8">
                 <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3">
          <div className="card-body d-flex align-items-center p-0">
            <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900">Group Joining Request</h2>

          </div>
                <div className="row ps-2 pe-2">
            {groupRequests.map((gr) => (
                
                <GroupJoiningCard key={gr.id} data={gr} type={"request"} />
            ))}          
        </div>
        </div>
            </div>
        }
        {
            page === 'members' &&
            <div className="col-xl-8 col-xxl-9 col-lg-8">
                 <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3">
          <div className="card-body d-flex align-items-center p-0">
            <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900">Group Members</h2>

          </div>
                <div className="row ps-2 pe-2">
            {groupMembers.map((gm) => (
                
                <GroupJoiningCard key={gm.id} data={gm} type={"member"} />
            ))}
        </div>
        </div>
            </div>
        }
      </div>
    </div>
  </div>            
</div>

    </div>
  )
}

export default Group